import { useEffect, useState } from 'react';
import { getToken } from '../authentication/authProvider';

/**
 * The ship day as the server's ShipDayService has it (T-204): the day on the
 * case, else the next Canada Post pickup from the site it ships from. The
 * admin never works a ship day out itself, so the label dialog, the deliveries
 * list and the Slack label card always agree.
 */
export interface ShipDayPlan {
  day: string | null;
  /** "Wed Nov 4". */
  dayLabel: string | null;
  /** 'case' = already on the case; 'pickup' = what the server will set. */
  source: 'case' | 'pickup' | null;
  /** The site whose pickup weekdays apply. */
  site: string | null;
  /** Why there is no day ("Canada Post pickup days are not set for …"). */
  missing: string | null;
}

export const fetchShipDayPlan = async (funeralId: number | string): Promise<ShipDayPlan | null> => {
  const apiUrl = (process.env.REACT_APP_PAPERMAN_API_URL || 'http://localhost:3001').replace(/\/$/, '');
  try {
    const token = await getToken();
    const r = await fetch(`${apiUrl}/delivery-scheduling/staff/${funeralId}/ship-day`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return r.ok ? ((await r.json()) as ShipDayPlan) : null;
  } catch {
    return null;
  }
};

export const useShipDayPlan = (funeralId: number | string | null | undefined, enabled = true): ShipDayPlan | null => {
  const [plan, setPlan] = useState<ShipDayPlan | null>(null);
  useEffect(() => {
    if (!enabled || funeralId == null) return;
    let live = true;
    void fetchShipDayPlan(funeralId).then((p) => {
      if (live) setPlan(p);
    });
    return () => {
      live = false;
    };
  }, [funeralId, enabled]);
  return plan;
};
